import { createRouter, RouterProvider } from "@tanstack/react-router";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Provider } from "jotai";
import "./api/interceptors";
import { jotaiStore } from "./components/store";
import { routeTree } from "./routeTree.gen";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 3,
      retry: 1,
    },
  },
});

export const router = createRouter({
  routeTree,
  defaultPreload: "intent",
});

export function RouterComponent() {
  return (
    <QueryClientProvider client={queryClient}>
      <Provider store={jotaiStore}>
        <RouterProvider router={router} />
      </Provider>
    </QueryClientProvider>
  );
}
